<template>
  <b-form-group
    label="Buton Bağlantı"
    label-for="cta_url"
  >
    <b-form-input
      id="cta_url"
      v-model="dataItem.cta_url"
      placeholder="Buton Bağlantı"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'CtaUrl',
  components: {
    BFormGroup,
    BFormInput,
  },
  computed: {
    dataItem() {
      return this.$store.getters['brands/dataItem']
    },
  },
}
</script>
